// src/mocks/image-editor.web.js
// Mock complet @react-native-community/image-editor v4.3.0

// ────── Web : mock qui ne fait rien mais évite les crashes ──────
const ImageEditor = {
  cropImage: async (uri, cropData) => {
    console.warn('[ImageEditor:web] cropImage mocké – retourne l’URI originale', uri);
    return uri; // retourne l’URI d’origine
  },
};

module.exports = ImageEditor;
module.exports.default = ImageEditor;